import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { ConnectFormDirective } from './connect-form.directive';
import { ClickOutsideDirective } from './click-outside.directive';
import { DialogPanelDirective } from './dialog-panel.directive';



@NgModule({
  declarations: [SafeHtmlPipe, ConnectFormDirective, ClickOutsideDirective, DialogPanelDirective],
  imports: [
    CommonModule
  ],
  exports:[
    TranslateModule,
    SafeHtmlPipe,
    ConnectFormDirective,
    ClickOutsideDirective,
    DialogPanelDirective
  ]
})
export class SharedModule { }
